import {
  AlignmentType,
  IReportCell,
} from "@iliotech/data-wire/src/stores/ReportBespoke/ReportBespokeStore";

export const getAlignmentStyles = (cell: IReportCell) => {
  const alignment = cell?.alignment;
  switch (alignment) {
    case AlignmentType.CENTER_LEFT:
      return {
        alignItems: "center",
        justifyContent: "flex-start",
        textAlign: "left",
      };
    case AlignmentType.CENTER_RIGHT:
      return {
        alignItems: "center",
        justifyContent: "flex-end",
      };
    case AlignmentType.CENTER_TOP:
      return {
        alignItems: "flex-start",
        justifyContent: "center",
        textAlign: "center",
      };
    case AlignmentType.CENTER_BOTTOM:
      return {
        alignItems: "flex-end",
        justifyContent: "center",
        textAlign: "center",
      };
    case AlignmentType.TOP_LEFT:
      return {
        alignItems: "flex-start",
        justifyContent: "flex-start",
        textAlign: "left",
      };
    case AlignmentType.BOTTOM_LEFT:
      return {
        alignItems: "flex-end",
        justifyContent: "flex-start",
        textAlign: "left",
      };
    case AlignmentType.TOP_RIGHT:
      return {
        alignItems: "flex-start",
        justifyContent: "flex-end",
      };
    case AlignmentType.BOTTOM_RIGHT:
      return {
        alignItems: "flex-end",
        justifyContent: "flex-end",
      };
    default:
      return {
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      };
  }
};
